import { Checkbox } from "@mui/material";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";

interface Props {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ConfirmTermsCheckbox: React.FC<Props> = ({ checked, onChange }) => {
  const { t } = useTranslation();

  return (
    <ConfirmTermsContainer>
      <Checkbox checked={checked} onChange={onChange} />
      <span>{t("library.exercises.form.confirm_no_copyrighted_media")}</span>
    </ConfirmTermsContainer>
  );
};

const ConfirmTermsContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.primary.base};
`;
